import React, {useEffect, useState} from "react";
import {CLayout} from "../../components";
import {useTranslation} from "react-i18next";
import {
    Autocomplete,
    Breadcrumbs,
    Button,
    Card,
    Chip,
    Divider,
    Dropdown,
    Grid,
    Menu,
    MenuButton,
    Typography,
    Tab,
    Tabs,
    TabList
} from "@mui/joy";
import {Link} from "react-router-dom";
import {Add, ChevronRight, FilterList} from "@mui/icons-material";
import AutoAwesome from '@mui/icons-material/AutoAwesome'; // Import de l'icône boost
import {get} from "../../api/api";
import "../../styles/events.scss";
import "./style.scss";
import {Pagination} from "@mui/material";
import Avatar from '@mui/joy/Avatar';

export const VEvents = (): React.ReactElement => {
    const {t} = useTranslation();

    const [events, setEvents] = useState<any[]>([]);
    const [categories, setCategories] = useState<any[]>([
        {
            subCategories: [
                {
                    id: 2,
                    name: "string"
                }
            ],
            id: 0,
            name: "string"
        }
    ]);
    const [subCategories, setSubCategories] = useState<any[]>([
        {
            category: {
                id: 0,
                name: "string"
            },
            slug: "string",
            id: 2,
            name: "string"
        }
    ]);
    const [subCategoriesFiltered, setSubCategoriesFiltered] = useState<any[]>([
        {
            category: {
                id: 0,
                name: "string"
            },
            slug: "string",
            id: 2,
            name: "string"
        }
    ]);
    const [localisation, setLocalisation] = useState<any[]>([
        {
            id: 0,
            name: "string"
        }
    ]);

    const [filterCategories, setFilterCategories] = useState<string | null>(null);
    const [filterSubCategories, setFilterSubCategories] = useState<string | null>(null);
    const [filterLocalisation, setFilterLocalisation] = useState<string | null>(null);

    const [pagination, setPagination] = useState<number>(0);
    const [page, setPage] = useState<number>(1);
    // État pour gérer l'onglet sélectionné : "FUTURE" ou "PAST"
    const [dateFilter, setDateFilter] = useState<"FUTURE" | "PAST">("FUTURE");
    const handleChangePage = (event: any, value: number) => {
        setPage(value);
    };

    useEffect(() => {
        void get({url: "categories"})
            .then((res) => setCategories(res.data))
            .catch((err) => console.log(err));

        void get({url: "sub-categories"})
            .then((res) => {
                setSubCategories(res.data);
            })
            .catch((err) => console.log(err));

        void get({url: "localisations"})
            .then((res) => setLocalisation(res.data))
            .catch((err) => console.log(err));
    }, []);

    useEffect(() => {
        document.title = `EevenPRO - ${t("Liste des évènements")}`;
    }, [t]);

    useEffect(() => {
        // Filtrage des sous-catégories en fonction de la catégorie sélectionnée
        if (filterCategories) {
            setSubCategoriesFiltered(
                subCategories.filter(
                    (subCategorie) => subCategorie.category.name === filterCategories
                )
            );
        } else {
            setSubCategoriesFiltered(subCategories);
        }
    }, [filterCategories, subCategories]);

    useEffect(() => {
        const start = (page - 1) * 10 + 1;
        const end = page * 10;
        // Construction de l'URL avec les filtres appliqués, y compris le filtre de date (FUTURE ou PAST)
        let url = `events?_end=${end}&_start=${start}&date_filter=${dateFilter}`;
        if (filterSubCategories) {
            url += `&sub_categories[]=${filterSubCategories}`;
        }
        if (filterLocalisation) {
            url += `&localisations[]=${filterLocalisation}`;
        }

        void get({url})
            .then((res) => {
                const contentRange = res.headers["content-range"];
                setPagination(Math.ceil(parseInt(contentRange?.split("/")[1]) / 10));
                setEvents(res.data);
            })
            .catch((err) => console.log(err));
    }, [page, filterSubCategories, filterLocalisation, dateFilter]);

    return (
        <CLayout>
            <section id={"VEvents"} className={"min-h-[600px]"}>
                <Card className={"rounded-none my-4 drop-shadow-lg"} variant={"outlined"}>
                    <div className={"flex items-center gap-4 justify-between w-full"}>
                        <Breadcrumbs separator={<ChevronRight/>} className={"!p-0"}>
                            <Link to={"/"}>{t("EevenPRO")}</Link>
                            <Typography>{t("Liste des évènements")}</Typography>
                        </Breadcrumbs>

                        <div className={"flex gap-4"}>
                            <Dropdown>
                                <MenuButton
                                    variant={"outlined"}
                                    className={"hover:!bg-transparent hover:!scale-110 transition"}
                                >
                                    <FilterList/>
                                </MenuButton>

                                <Menu className={"w-[500px] !p-4 gap-4"}>
                                    <Typography>{t("Filtres")}</Typography>

                                    <div className={"flex justify-between gap-4"}>
                                        <Typography>{t("Catégories")}</Typography>
                                        <Autocomplete
                                            onChange={(event, newValue) => {
                                                setFilterCategories(newValue?.name || "");
                                            }}
                                            className={"w-[70%]"}
                                            options={categories}
                                            value={
                                                categories?.find((cat) => cat.name === filterCategories) ||
                                                null
                                            }
                                            getOptionLabel={(option: any) => option?.name || ""}
                                            isOptionEqualToValue={(option: any, value: any) =>
                                                option?.name === value
                                            }
                                        />
                                    </div>

                                    <div className={"flex justify-between gap-4"}>
                                        <Typography>{t("Sous-catégories")}</Typography>
                                        <Autocomplete
                                            onChange={(event, newValue) => {
                                                setFilterSubCategories(newValue?.id);
                                            }}
                                            className={"w-[70%]"}
                                            value={
                                                subCategories?.find(
                                                    (subCat) => subCat.id === filterSubCategories
                                                ) || null
                                            }
                                            options={subCategoriesFiltered}
                                            getOptionLabel={(option: any) =>
                                                `${option?.category?.name} (${option?.name})` || ""
                                            }
                                            isOptionEqualToValue={(option: any, value: any) =>
                                                option?.id === value
                                            }
                                        />
                                    </div>

                                    <div className={"flex justify-between gap-4"}>
                                        <Typography>{t("Localisations")}</Typography>
                                        <Autocomplete
                                            onChange={(event, newValue) => {
                                                setFilterLocalisation(newValue?.id);
                                            }}
                                            className={"w-[70%]"}
                                            value={
                                                localisation?.find((loc) => loc.id === filterLocalisation) ||
                                                null
                                            }
                                            options={localisation}
                                            getOptionLabel={(option: any) => option?.name || ""}
                                            isOptionEqualToValue={(option: any, value: any) =>
                                                option?.id === value
                                            }
                                        />
                                    </div>
                                </Menu>
                            </Dropdown>

                            <Button
                                color={"primary"}
                                className={"!text-white hover:!scale-105 transition"}
                                onClick={() => (window.location.href = "/events/create")}
                            >
                                {t("Ajouter un évènement")} <Add className={"!fill-white"}/>
                            </Button>
                        </div>
                    </div>
                </Card>
                <Grid xs={4}>
                    <Typography
                        level={"h4"}
                        className={"!mt-4 !text-3xl !text-black !mb-4"}
                    >
                        Mes évènements
                    </Typography>
                </Grid>
                {/* Onglets pour filtrer par date (évènements à venir / passés) */}
                <Tabs
                    value={dateFilter}
                    onChange={(event, newValue) => {
                        if (newValue !== null) {
                            setDateFilter(newValue as "FUTURE" | "PAST");
                            setPage(1);
                        }
                    }}
                    aria-label="Filtrer par date"
                    sx={{mb: 2}}
                >
                    <TabList>
                        <Tab value="FUTURE">Évènements à venir</Tab>
                        <Tab value="PAST">Évènements passés</Tab>
                    </TabList>
                </Tabs>

                <Grid container spacing={2} className={"justify-between items-center !mb-[.5rem]"}>
                    <Grid xs={8}>
                        <Pagination
                            className={"!text-black"}
                            count={pagination}
                            shape="rounded"
                            onChange={handleChangePage}
                        />
                    </Grid>
                </Grid>
                <Grid spacing={2} container className={"overflow-y-auto max-h-[550px]"}>
                    {events?.map((event, key) => (
                        <div className={"w-full"} key={key}>
                            {showEvent(event, key)}
                        </div>
                    ))}
                </Grid>
            </section>
        </CLayout>
    );
};

const showEvent = (event: any, key: number) => {
    return (
        <Grid key={key} xs={12}>
            <Card
                key={key}
                className={
                    "z-1 hover:drop-shadow-lg hover:!scale-[0.98] duration-200 transition hover:cursor-pointer cardEvents"
                }
                onClick={() => (window.location.href = `/events/show?id=${event.id}`)}
            >
                <Grid container spacing={2}>
                    {/* Image de l'événement */}
                    <Grid xs={"auto"}>
                        <Avatar alt="image event" src={event.urls_image[0]} size="lg"/>
                    </Grid>
                    {/* Infos générales de l'événement */}
                    <Grid spacing={0} container xs={12} md={5}>
                        <Grid xs={"auto"}>
                            <Typography level={"h4"}>
                                {event.name}
                                {event?.boosted && (
                                    <Chip
                                        className="!px-4 !py-1 !ml-2"
                                        color="warning"
                                        startDecorator={<AutoAwesome className="!fill-white"/>}
                                    >
                                        Boosté
                                    </Chip>
                                )}
                            </Typography>
                        </Grid>

                        <Grid xs={12} className="!mt-1">
                            <span>
                                {new Date(event.start_date).toLocaleString("fr-FR")} -{" "}
                                {new Date(event.end_date).toLocaleString("fr-FR")}
                            </span>
                        </Grid>
                    </Grid>

                    {/* Statistiques de l'événement */}
                    <Grid
                        xs={12}
                        md={5}
                        container
                        spacing={0}
                        className="justify-center stats flex-wrap gap-2"
                    >
                        <Grid xs={"auto"} className="flex flex-col items-center justify-center">
                            <Chip className="!px-4 !py-1" color="primary">

                                {event?.views} Vues
                            </Chip>
                        </Grid>

                        <Grid xs={"auto"} className="flex flex-col items-center justify-center">
                            <Chip className="!px-4 !py-1" color="primary">
                                {event?.likes} Like
                            </Chip>
                        </Grid>

                        <Grid xs={"auto"} className="flex flex-col items-center justify-center">
                            <Chip className="!px-4 !py-1" color="primary">
                                {event?.interests} Intérêts
                            </Chip>
                        </Grid>

                        <Grid xs={"auto"} className="flex flex-col items-center justify-center">
                            <Chip className="!px-4 !py-1" color="primary">
                                {event?.shares} Partages
                            </Chip>
                        </Grid>
                    </Grid>
                </Grid>
            </Card>
        </Grid>
    );
};